import { Directive, ElementRef, AfterViewInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import * as $ from 'jquery';
import 'assets/vendor/bootstrap-datepicker/js/bootstrap-datepicker';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appCalendar]'
})
export class CalendarDirective implements AfterViewInit, OnDestroy {
    @Input() ngModel: string;
    @Output() ngModelChange: EventEmitter<string> = new EventEmitter<string>();
    element: any;

    constructor(
        private elementRef: ElementRef//,
        //private control: NgControl
    ) { }


    ngOnDestroy(): void {
        this.element.datepicker('destroy');
    }

    ngAfterViewInit(): void {
        this.element = $(this.elementRef.nativeElement);

        this.element.datepicker({ format: 'dd/mm/yyyy' }).on('changeDate', function (event) {

            this.childNodes[0].value = event.date;

        });
    }
}
